import { useContext } from "react";
import { DatabaseValue } from "../contexts/database";
import { Select, Option } from "../select";
export default function Table({ value, onChange, params }) {
  const tables = useContext(DatabaseValue);

  return (
    <div>
      <Select value={value} onChange={(v) => onChange(v)} className="dropdown">
        {tables.map((t) => {
          return (
            <Option key={t.id} value={t.id}>
              {t.name}
            </Option>
          );
        })}
      </Select>
    </div>
  );
}
